import Api from '@/services/Api'

export default {
  fetchCustomers () {
    return Api().get('customers')
  },

  fetchCustomersBySearch (search) {
    return Api().post('customersBySearch', {search: search})
  },

  fetchLimitedCustomers (page, rowsPerPage, search) {
    return Api().post('limitedCustomers', {
      page: page,
      rowsPerPage: rowsPerPage,
      search: search
    })
  },

  countCustomers (search) {
    return Api().post('countCustomers', {
      search: search
    })
  },

  addCustomer (customer) {
    return Api().post('customers', customer)
  },

  updateCustomer (params) {
    return Api().put('customer/' + params.customer._id, params.customer)
  },

  updateAddress (params) {
    return Api().put('address/' + params.address._id, params.address)
  },

  getCustomer (id) {
    return Api().get('customer/' + id)
  },

  deleteCustomer (id) {
    return Api().delete('customer/' + id)
  },

  getOrders (id) {
    return Api().get('ordersByCustomer/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/services/CustomerService.js